import { render, staticRenderFns } from "./DoKoLastTrick.vue?vue&type=template&id=e40f0c50&scoped=true&"
import script from "./DoKoLastTrick.vue?vue&type=script&lang=ts&"
export * from "./DoKoLastTrick.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40f0c50",
  null
  
)

/* custom blocks */
import block0 from "./DoKoLastTrick.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports